import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { SystemGlobalsService } from '../../system-globals.service';

@Component({
  selector: 'otp',
  templateUrl: './otp.component.html',
  styleUrls: ['./otp.component.scss']
})
export class OtpComponent implements OnInit {

  public hasErrors: boolean = false;
  public errorMessage: string = '';

  constructor(private route: ActivatedRoute, private router: Router, private authService: AuthService, public globals: SystemGlobalsService) { }

  ngOnInit() {
    const token = this.route.snapshot.paramMap.get('token');
    let redirect: string = this.globals.getUrlParamByName('redirect');
    const sendUserIdOnRedirect = this.globals.getUrlParamByName('sendUserIdOnRedirect');
    let onErrorRedirectUrl = this.globals.getUrlParamByName('onErrorRedirectUrl');

    if (redirect) redirect = atob(redirect);
    if (onErrorRedirectUrl) onErrorRedirectUrl = atob(onErrorRedirectUrl);
    
    this.authService.signinOtp(token).subscribe(
      success => {
        if (redirect) {
          let userId = atob(token.split('-')[0]);

          if (sendUserIdOnRedirect == 'true') redirect = this.globals.updateQueryString('systemUserId', userId, redirect);
          
          window.location.href = redirect;
        }
        else window.location.href = '/';
      },
      error => {
        this.errorMessage = error.error.name ? error.error.name : error.error.text;
        this.hasErrors = true;
        
        if (onErrorRedirectUrl) window.location.href = this.globals.updateQueryString('errorMsg', encodeURIComponent(this.errorMessage), onErrorRedirectUrl);
      }
    )
  }

}
